enum StatusAutorizacaoEnum {
  Cancelada = 'cancelada',
  Autorizada = 'autorizada',
  AutorizadaParcial = 'autorizadaParcial',
  Analise = 'Analise',
}

export default StatusAutorizacaoEnum
